import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding/step-5` — carrier API access intake.
 * Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding/step-5",
	component: lazyRouteComponent(() => import("./step-5.page")),
})
